import { render } from "./Image2Card.vue?vue&type=template&id=6c8181f8&scoped=true"
import script from "./Image2Card.vue?vue&type=script&lang=js"
export * from "./Image2Card.vue?vue&type=script&lang=js"

import "./Image2Card.vue?vue&type=style&index=0&id=6c8181f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8181f8"]])

export default __exports__